<template>
    <div class="my-5">
        <h3>Voci di preventivo</h3>
        <div v-for="(input, index) in inputs" :key="index">
            <div class="row align-items-center single-quote-section">
                <div class="col-auto bg-light">
                    {{ (index+1) }}
                </div>
                <div class="col">
                    <select-item
                        v-model="inputs[index].section"
                        @input="setSectionData(index)"
                        action="/quotes/section/list"
                        item-value="id"
                        item-text="title"
                        :return-object="true"
                        :clearable="true"
                        :label="sectionLabel"
                        :cache-items="false"
                    ></select-item>
                    <v-text-field :name="'quote_sections[' + index + '][title]'" v-model="inputs[index].title" :label="titleLabel"
                        type="text"></v-text-field>
                    <tiptap-vuetify v-model="inputs[index].description"
                        :extensions="extensions"
                        :label="descriptionLabel" />
                    <input type="hidden" :name="'quote_sections[' + index + '][description]'" v-model="inputs[index].description">
                </div>
                <div class="col-auto">
                    <button class="btn btn-danger rounded-circle row-btn" type="button" @click="removeInput(index)">-</button> 
                </div>
            </div>
        </div>
        <div class="text-center">
            <button class="btn row-btn btn-info add-row" type="button" @click="addInput">+</button>
        </div>
    </div>
</template>
  
<script>
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify'

export default {
    components: { TiptapVuetify },
    data: () => ({
        // declare extensions you want to use
        extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [Heading, {
            options: {
            levels: [1, 2, 3]
            }
        }],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak
        ],
    }),
    name: "QuoteSections",
    props: {
        value: {type: Array, default: [{title: '', description: ''}]},
        label:{default:'Voci di preventivo'},
        loading:{default:false},
        multiple:{default:false},
        disabled:{default:false},
        required:{default:false},
        name:{},
        rules:{},
        titleLabel: {default: 'Titolo'},
        descriptionLabel: {default: 'Descrizione'},
        sectionLabel: {default: 'Scegli allegato o compila manualmente'},
    },
    computed: {
        inputs: {
            get() {
                if(!this.value) {
                    return [{title: '', description: ''}];
                }else {
                    return this.value;
                }
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        }
    },
    methods: {
        addInput() {
            this.inputs.push({ section: null, title: "", description: "" });
            this.$emit('input', this.inputs);
        },
        removeInput(index) {
            this.inputs.splice(index, 1);
            this.$emit('input', this.inputs);
        },
        setSectionData(index) {
            if(this.inputs[index].section) {
                var section = this.inputs[index].section;
                this.inputs[index].title = section.title;
                this.inputs[index].description = section.description;
            }
            this.$emit('input', this.inputs);                
        },
    },
};
</script>